export function formatPlaceOptionLabel(display: string) {
  const cityName = display.split(",")[0].trim();
  const region = display.slice(cityName.length + 1).trim();
  const label = region ? `${cityName}, ${region}` : cityName;
  return { cityName, region, label };
}
